import { BookImage, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import { routes } from 'app/store/routes'
import { Link } from 'react-router-dom'
import { getSlug } from 'utils'

interface Props {
  className?: string
  book: Partial<Book>
  hidden?: boolean
  currentBook?: boolean
}

export const ClubDetailBook = ({
  className,
  book,
  hidden = false,
  currentBook = false,
}: Props) => {
  const { colors, motion, mediaQueries } = useTheme()

  if (!book) return null

  const isTVShow = book.type === 'tv_show'
  const currentLabel = isTVShow ? 'watching' : 'reading'

  return (
    <Link
      to={`${routes.book}/${getSlug(book.url)}`}
      className={css`
        display: block;
        ${mediaQueries.tabletL} {
          opacity: ${hidden ? 0 : 1};
          pointer-events: ${hidden || isTVShow ? 'none' : 'auto'};
          ${motion.transition('opacity')}
        }
      `}
    >
      <div
        className={cx(
          css`
            position: relative;
            border-radius: 8px;
            overflow: hidden;
          `,
          className
        )}
      >
        <BookImage
          className={css`
            width: 100%;
            height: 288px;
            border-radius: 0;
            img {
              height: 100%;
              object-fit: cover;
            }
          `}
          image={book.cover_image as string}
          altTag={`${book.title} book cover`}
          size={400}
        />
        {currentBook ? (
          <Text
            className={css`
              padding: 6px 8px;
              text-transform: uppercase;
              background-color: rgba(0, 0, 0, 0.6);
              border-radius: 16px;
              width: 120px;
              position: absolute;
              bottom: 8px;
              left: 50%;
              transform: translateX(-50%);
            `}
            type="label"
            sizing="M"
            color={colors.titaniumWhite}
            align="center"
          >
            <b>Currently {currentLabel}</b>
          </Text>
        ) : null}
      </div>
    </Link>
  )
}
